export default "__VITE_ASSET__COvNjfDa__"